module.exports = __webpack_public_path__ + "static/img/resume-material-dark-projects.2be7bcf.png";